import { AuthorizedClient } from '~/app-modules/core/clients/authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { UiDictionariesDtoSchema } from '~/app-modules/core/clients/dto/ui-dictionaries.dto';
import { UserStore } from '~/app-modules/user/stores/user.store';

@singleton()
export class UiDictionariesClient extends AuthorizedClient {
  constructor(http: HttpConnection, authService: AuthService, userStore: UserStore) {
    super(http, authService, userStore);
  }

  async getUiDictionaries() {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/ui-dictionaries',
      },
      UiDictionariesDtoSchema,
    );
  }
}
